var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"of-content5-category"},[_c('div',{staticClass:"cat-content-title"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.category.title)}})]),_vm._v(" "),_c('div',{staticClass:"cat-content-items"},[_vm._l((_vm.category.items),function(item){return _vm._t("categoryItem",null,{"item":item})})],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da93c59a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/office/js/components/dashboard/onboardingFunnel/content-5/category.vue
// module id = MheC
// module chunks = 0